import store from './store';
import { IStorageState } from '../interfaces';

const KEY = 'art-text-maker-3';

export const saveToSessionStorage = (value: any) => {
    if(!window.sessionStorage) return;

    const encoded = encodeURIComponent(JSON.stringify(value));
    try{
        sessionStorage.setItem(KEY, encoded);
    }
    catch(ex){}
};

export const getFromSessionStorage = () => {
    if(!window.sessionStorage) return null;

    const value = sessionStorage.getItem(KEY);
    if(!value) return null;

    let parsed = null;

    try{
        parsed = JSON.parse(decodeURIComponent(value));
    }
    catch (ex){}

    return parsed;
};

export const saveStateToStorage = () => {
    const state = store.getState();

    const storageState: IStorageState = {
        colors: state.form.colors,
        backgroundColor: state.form.backgroundColor,
        backgroundColorEnabled: state.form.backgroundColorEnabled,

        text: state.root.text,
        category: state.root.category,
    };

    saveToSessionStorage(storageState);
};